<div class="pagination d-flex justify-content-end align-items-center mt-3">
    <div class="right me-3">
        <mat-form-field appearance="outline" class="size-input me-3">
            <mat-label>Page</mat-label>
            <input matInput type="number" min="1" [max]="totalPages" [(ngModel)]="pagination.pageInput"
                (keyup.enter)="goToPage(pagination.pageInput)" />
            <mat-hint align="end">of {{ totalPages }}</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="size-input">
            <mat-label>Rows</mat-label>
            <input matInput type="number" min="1" [(ngModel)]="pagination.pageSize" (keydown.enter)="onPageSizeChange()" />
        </mat-form-field>
    </div>

    <div class="left">
        <button mat-stroked-button color="primary" (click)="prevPage()" [disabled]="pagination.currentPage <= 1">
            <mat-icon>chevron_left</mat-icon>
            Prev
        </button>

        <ng-container *ngFor="let p of pagination.visiblePages">
            <button mat-button [color]="p === pagination.currentPage ? 'primary' : undefined" (click)="goToPage(p)"
                [disabled]="p === pagination.currentPage">
                {{ p }}
            </button>
        </ng-container>

        <button mat-stroked-button color="primary" (click)="nextPage()" [disabled]="pagination.currentPage >= totalPages">
            Next
            <mat-icon>chevron_right</mat-icon>
        </button>
    </div>
</div>